import React from "react"
import { Row, Col } from "reactstrap"

const SectionTitle = props => {
  return (
    <>
      <Row className="justify-content-center">
        <Col xs="12" className={props.isLeft ? "" : "text-center"}>
          <div className="section-title mb-4 pb-2" name="maintitle">
            <h4 className="title mb-4" name="sectiontitle">
              {" "}
              {props.title}{" "}
            </h4>
            <p
              className={
                props.isLeft
                  ? "text-muted para-desc mb-0"
                  : "text-muted para-desc mx-auto mb-0"
              }
              name="sectiondesc"
            >
              {/* Start working with{" "}
              <span className="text-primary fw-bold">Landrick</span>{" "} */}
              {props.desc}
            </p>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default SectionTitle
